import { type RepositoryView } from 'app/api/clients/provisioning/v0alpha1';

import { generateNewBranchName } from './utils/newBranchName';

export function getDefaultWorkflow(config?: RepositoryView, loadedFromRef?: string) {
  if (loadedFromRef && loadedFromRef !== config?.branch) {
    return 'write'; // use write when the value targets an explicit ref
  }
  return config?.workflows?.[0];
}

export function getCanPushToConfiguredBranch(repository?: RepositoryView) {
  return repository?.workflows?.includes('write') ?? false;
}

export function getDefaultRef(repository: RepositoryView | undefined, branchPrefix: string, loadedFromRef?: string) {
  const workflow = getDefaultWorkflow(repository, loadedFromRef);
  if (workflow === 'branch') {
    return generateNewBranchName(branchPrefix);
  }
  // Opened from a branch preview, the write default saves back to that branch; the configured branch
  // is only the target when the repository can't push anywhere else.
  if (loadedFromRef && loadedFromRef !== repository?.branch && repository?.workflows?.includes('branch')) {
    return loadedFromRef;
  }
  return repository?.branch ?? '';
}
